/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import BlockIcon from "@material-ui/icons/Block";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openEditAccessRolePage, setCurrentItem, setOpenModal, allowEdit }
) => (
  <>
    {allowEdit && (
      <OverlayTrigger
        overlay={<Tooltip id="folder-edit-tooltip">Edit Folder</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => {
            openEditAccessRolePage(row.uuid);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    )}
    {/* <OverlayTrigger
      overlay={
        <Tooltip id="folder-detail-tooltip">
          {row.is_active ? "NON AKTIFKAN" : "AKTIFKAN"}
        </Tooltip>
      }
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm mx-3"
        onClick={() => {
          setCurrentItem(row);
          setOpenModal(prev => ({ ...prev, confirmation: true }));
        }}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          {row.is_active ? <BlockIcon /> : <CheckCircleIcon />}
        </span>
      </a>
    </OverlayTrigger> */}
  </>
);
